import { File05, FileCheck02, MessageChatCircle, Truck01 } from '@untitled-ui/icons-react/build/cjs';
import { IWidget } from 'src/components/WidgetSettingsModal/widgetSettings.interface';
import { transformWidgets as _transformWidgets, WidgetTitleMap } from 'src/utils/widgetSettings.utils';

export type Widget = IWidget;

export const ORDER_WIDGET_IDS = {
    MAP_IT: 'map-it',
    DOCUMENTS: 'documents',
    TERMS_AND_CONDITION: 'terms-and-condition',
    MESSAGES: 'messages',
} as const;

const PORTAL_WIDGET_TITLE_DES: WidgetTitleMap = {
    [ORDER_WIDGET_IDS.MAP_IT]: {
        title: 'Tracking',
        description: 'Track and visualize order location on map',
        icon: Truck01,
    },
    [ORDER_WIDGET_IDS.DOCUMENTS]: {
        title: 'Documents',
        description: 'View and manage order-related documents',
        icon: File05,
    },
    [ORDER_WIDGET_IDS.TERMS_AND_CONDITION]: {
        title: 'Terms & Conditions',
        description: 'View terms and conditions for this order',
        icon: FileCheck02,
    },
    [ORDER_WIDGET_IDS.MESSAGES]: {
        title: 'Messages',
        description: 'View and send messages for this order',
        icon: MessageChatCircle,
    },
};

// Default widget configuration — shown when the user has no saved settings yet
export const DEFAULT_WIDGET_SETTINGS: Record<string, { isEnabled: boolean; position: number }> = {
    [ORDER_WIDGET_IDS.MAP_IT]: { isEnabled: true, position: 0 },
    [ORDER_WIDGET_IDS.DOCUMENTS]: { isEnabled: true, position: 1 },
    [ORDER_WIDGET_IDS.TERMS_AND_CONDITION]: { isEnabled: true, position: 2 },
    [ORDER_WIDGET_IDS.MESSAGES]: { isEnabled: true, position: 3 },
};

export const transformWidgets = (widgetsData: any): Widget[] => _transformWidgets(widgetsData, PORTAL_WIDGET_TITLE_DES);
